export default __webpack_public_path__ + "static/media/active-station-types-icon.06978707.svg";